<nz-form-item [formGroup]="formGroup()">
	<nz-form-label [nzSpan]="7" [nzRequired]="required()">
		{{ label() }}
	</nz-form-label>

	<nz-form-control [nzSpan]="12" nzHasFeedback nzValidatingTip="Validating..." [nzErrorTip]="errorTpl">
		<nz-date-picker [formControlName]="controlName()" [nzPlaceHolder]="placeholder()"></nz-date-picker>

		<ng-template #errorTpl let-control>
			@if (control.errors?.['required']) {
				This field is required
			}
			@if (control.errors?.['matDatepickerParse']) {
				Invalid date format
			}
		</ng-template>
	</nz-form-control>
</nz-form-item>
